export const REDUCER_NAME="employeeSlice";
export interface iEmployeeDTO {
    id?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    mobile?: string;
    role?: string;
    lastLogin?: string | Date;
    address?: string;
    password?:string;
    confirmPassword?:string;
    module?:Array<string>;
    wholesalers?: Array<{ id?: string; name?: string; email?: string }>;
    profilePicture?:string|File;    
}

export interface iEmployeeState {
    employeeList: iEmployeeDTO[] | null;
    isLoading: boolean;
    errorMessage: string | null;
}
